import React from 'react';
import { useLocation } from 'react-router-dom';
import utils from 'utils';

import MenuOption from './MenuOption';
import { useDispatch } from 'react-redux';
import actions from 'state/actions';

interface Props {
  name: string;
  isFirst?: boolean;
  isMenuOpen?: boolean;
  id: number;
}

const MenuItem = (props: Props) => {
  const { name, isFirst = false, isMenuOpen = true } = props;
  const { pathname } = useLocation();
  const techName = utils.converter.techName(name);
  const dispatch = useDispatch();
  return (
    <MenuOption
      link={`/${techName}`}
      onClick={() => {
        dispatch(actions.chatbot.setDisplayMode('floating'));
        isMenuOpen && dispatch(actions.app.toggleMenu());
      }}
      text={name}
      id={props.id}
      isActive={pathname.split('/')[1] === techName}
      isFirst={isFirst}
      isMenuOpen={isMenuOpen}
    />
  );
};

export default MenuItem;
